import React from "react";
import { v4 as uuidv4 } from "uuid";

import { Card } from "@material-ui/core";

function TimelineLoader() {
  const renderItems = () => {
    const items = [];
    for (let i = 0; i < 5; i++) {
      items.push(
        <Card className="timeline-loader-container" key={uuidv4()}>
          <div className="timeline-loader-top" />
          <div className="timeline-loader-bottom" />
        </Card>,
      );
    }
    return items;
  };

  return <div className="timeline-loader-wrapper">{renderItems()}</div>;
}

export default TimelineLoader;
